/** @returns {boolean} True when an API error indicates the unit no longer exists. */
export function isUnitNotFoundError(error) {
  if (!error) return false;
  const status = Number(error.status);
  const msg = String(error?.message || error?.response?.message || error?.response?.error || '')
    .trim()
    .toLowerCase();
  if (status === 404) return true;
  if (status === 400 && (msg.includes('not found') || msg.includes('no longer'))) return true;
  return msg === 'unit not found';
}
